__turbopack_context__.v({
  "filters": "job-overview-module-scss-module__R3bGDW__filters",
  "job": "job-overview-module-scss-module__R3bGDW__job",
  "job-list": "job-overview-module-scss-module__R3bGDW__job-list",
  "placeholder": "job-overview-module-scss-module__R3bGDW__placeholder",
  "section": "job-overview-module-scss-module__R3bGDW__section",
  "select": "job-overview-module-scss-module__R3bGDW__select",
});
